import React from "react";

const ArticleSkeleton = () => {
  return (
    <div className="animate-pulse w-[300px] h-[500px]">
      <div className="bg-gray-400 rounded-[24px] h-full">&ensp;</div>
    </div>
  );
};

export default ArticleSkeleton;
